import React, { useEffect, useState } from "react";
import api from "@/lib/api";

// Dropdown of the Discord server's voice channels. `defaultLabel` adds a "use default" option.
export default function VoiceChannelSelect({ value, onChange, defaultLabel, testId }) {
  const [voice, setVoice] = useState(null);
  useEffect(() => {
    api.get("/admin/discord/channels").then(({ data }) => setVoice(data.voice || [])).catch(() => setVoice([]));
  }, []);
  const known = (voice || []).some((c) => c.id === value);
  return (
    <select
      value={value || ""}
      onChange={(e) => {
        const c = (voice || []).find((x) => x.id === e.target.value);
        onChange(e.target.value, c ? c.name : "");
      }}
      className="w-full mt-1 p-2 bg-black/40 border border-[var(--ff-border)] text-sm"
      data-testid={testId}
    >
      <option value="">{defaultLabel || "— No room —"}</option>
      {value && !known && <option value={value}>Current room ({value})</option>}
      {voice === null && <option disabled>Loading voice channels…</option>}
      {(voice || []).map((c) => <option key={c.id} value={c.id}>🔊 {c.name}{c.stage ? " (stage)" : ""}</option>)}
    </select>
  );
}
